// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';
import {GovernmentTaxId} from '../customer/government-tax-id';

export const OriginalCustomerValues = t.struct({
    businessName1: t.String,
    businessName2: t.String,
    doingBusinessAs: t.String,
    familiarName: t.String,
    firstName: t.String,
    generation: t.String,
    lastName: t.String,
    middleName: t.String,
    prefix: t.String,
    suffix: t.String,
    governmentTaxIds: t.list(GovernmentTaxId)
}, {
    defaultProps: {
        businessName1: '',
        businessName2: '',
        doingBusinessAs: '',
        familiarName: '',
        firstName: '',
        generation: '',
        lastName: '',
        middleName: '',
        prefix: '',
        suffix: '',
        governmentTaxIds: []
    },
    name: 'OriginalCustomerValues'
});
